import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminPositionIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class AdminPositionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AdminPosition-001";

        let QBE = {
            "ShifamedMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "AdminPosition": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.AdminPosition.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_positions",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminPositionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminPosition = {};

        adminPosition["USID"] = this.getAttributeValue("USID");
        adminPosition["Name"] = this.getAttributeValue("Name");
        adminPosition["OrganizationUSID"] = this.getAttributeValue("OrganizationUSID");
        adminPosition["ParentUSID"] = this.getAttributeValue("ParentUSID");
        adminPosition["PrimaryEmployeeUSID"] = this.getAttributeValue("PrimaryEmployeeUSID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminPosition-001";
        payload.ShifamedMessage.AdminPosition = adminPosition;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/admin_positions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPosition-001",
                "idoc-response": "v1.AdminPosition-001"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminPositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminPosition-001";
        payload.ShifamedMessage.AdminPosition = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_positions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPosition-001",
                "idoc-response": "v1.AdminPosition-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminPositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminPosition-001";
        payload.ShifamedMessage.AdminPosition = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t3/v1/admin_positions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminPosition-001",
                "idoc-response": "v1.AdminPosition-001",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default AdminPositionEnterpriseComponent;